// createSamplingEvent/slice.js

import {
  createSamplingEventUIInitialState,
  createSamplingEventInitialState,
} from "./createSamplingEventState";
import {
  makeCreateSamplingEventUIActions,
  makeCreateSamplingEventActions,
} from "./createSamplingEventActions";

export const createCreateSamplingEventUISlice = (set, get) => ({
  createSamplingEventUI: createSamplingEventUIInitialState,
  createSamplingEventUIActions: Object.freeze(
    makeCreateSamplingEventUIActions(set, get)
  ),
});

export const createCreateSamplingEventSlice = (set, get) => ({
  createSamplingEvent: createSamplingEventInitialState,
  createSamplingEventActions: Object.freeze(
    makeCreateSamplingEventActions(set, get)
  ),
});
